import { AuthService } from './Services/auth.service';
import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { RouterModule } from '@angular/router';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ComponentsModule } from './components/components.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AuthConfigModule } from './auth/auth-config.module';
import { StorageService } from './Services/storage.service';
import { NgIdleModule } from '@ng-idle/core';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { PipesModule } from './Pipes/pipes.module';
import { appInitializerFactory } from './app-initialize.factory';
import { MatSelectModule } from '@angular/material/select';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { PermissionsService } from './Services/permissions.service';
import { DirectivesModule } from './directives.module';
import { environment } from '../environments/environment';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  declarations: [
    AppComponent,
    AuthLayoutComponent,
    AdminLayoutComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    FormsModule,
    NgxDaterangepickerMd.forRoot(),
    HttpClientModule,
    NgbModule,
    ComponentsModule,
    PipesModule,
    NgxIntlTelInputModule,
    BsDropdownModule.forRoot(),
    NgIdleModule.forRoot(),
    DirectivesModule,
    TranslateModule.forRoot(
      {
        defaultLanguage: environment.defaultLocale,
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      }
    ),
    AuthConfigModule,
    MatSelectModule
  ],
  providers: [
    AuthService,
    PermissionsService,
    StorageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, StorageService, Injector],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
